import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import rex1 from '../../assets/img-rex-1.png';
import rex2 from '../../assets/img-rex-2.png';
import rex3 from '../../assets/img-rex-3.png';
import rex4 from '../../assets/img-rex-4.png';
import rex5 from '../../assets/img-rex-5.png';
import { useTranslation } from "react-i18next";

export const RexSeed = () =>{
    const { t } = useTranslation()
    return(
        <>
        <Container className="projectBody ">
        <Row xs='1' >
            <Col className="projectInfo" lg='5' >
            <h3>Rex Seed</h3>
            <p className="roleText">{t("ui_design")} &nbsp; &bull; &nbsp; {t("frontend_development")}</p>
            <p className="parragraph">
            {t("rex_1parragraph")}
             <br/><br/>
             {t("rex_2parragraph")}
             <br/><br/>
             {t("rex_3parragraph")}
             <br/><br/>
             {t("rex_4parragraph")}
             <br/><br/>
             {t("rex_5parragraph")}
             <br/><br/>
             {t("rex_6parragraph")}
             <br/><br/>
             {t("rex_7parragraph")}
            </p>

            </Col>
            <Col className="projectDetails" lg='7'>
            <img src={rex1} style={{width:'100%'}} alt=""></img>
            <img src={rex2} style={{width:'100%'}} alt=""></img>
            <img src={rex3} style={{width:'100%'}} alt=""></img>
            <img src={rex4} style={{width:'100%'}} alt=""></img>
            <img src={rex5} style={{width:'100%'}} alt=""></img>
            </Col>
        </Row>
        </Container>
        </>
    )
}

export default RexSeed;
